import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  pushTemplates:state => state.pushTemplates,
};
